<template>
  <div class="w-11/12 mx-auto mb-20 lg:w-3/4 mt-20 lg:mt-32">
    <div class="flex items-center mb-3 justify-between">
      <div class="py-3 pl-2 text-background-academy text-xl
        md:text-2xl w-full">
        <h1 class="flex">
          {{ $t('slotsCreation.calendarTitle').toUpperCase() }} </h1>
        <div v-if="ready && events.length===0" class="italic text-lg text-beige-academy-500 mt-8">
          {{ $t('bookingSlots.noLessons')}}
        </div>
      </div>
      <div id="buttonChangeTimezone"
        class="flex sm:flex-row sm:justify-end flex-col justify-center w-full"
        v-if="teacherTimezone">
        <button
          v-if="choosenTimezone!==teacherTimezone"
          @click="switchToTeacherTimezone"
          class="bg-background-academy text-white shadow-xl p-2 lg:p-4 rounded-lg text-xs
            font-sans-serif font-bold transform hover:scale-105 duration-300">
            {{$t('timezone.seeLessons')}} <br>
            ( {{teacherTimezone}} )
        </button>
        <button
          v-else
          @click="comeBackToChoosenTimezone"
          class="bg-background-academy text-white shadow-xl p-2 lg:p-4 rounded-lg text-xs
            font-sans-serif font-bold transform hover:scale-105 duration-300">
            {{$t('timezone.comeBack')}} <br> ( {{ lastTimezone }} )
        </button>
      </div>
    </div>
    <vue-cal v-if="screenWidth>700"
      :disable-views="['years', 'year', 'month']"
      hide-view-selector
      :time-from="timeFrom"
      :time-to="timeTo"
      :time-step="45"
      :events="events"
      class="font-sans-serif"
      :on-event-dblclick="onEventClick"
      :editable-events="{
        title: false, drag: false, resize: false, delete: true, create: true }"
      :snap-to-time="15"
      :locale='$i18n.locale'
      :time-cell-height="60"
    />

    <div v-else class="flex justify-center items-center font-sans-serif">
      <vue-cal
        hide-view-selector
        :disable-views="['years', 'year', 'week']"
        :time-from="timeFrom"
        :time-to="timeTo"
        :time-step="45"
        active-view="month"
        xsmall
        :events="events"
        class="vuecal--rounded-theme vuecal--date-picker"
        :on-event-dblclick="onEventClick"
        :editable-events="{
          title: false, drag: false, resize: false, delete: true, create: true }"
        :snap-to-time="15"
        style="height: 25rem"
        :locale='$i18n.locale'
      />

    </div>

    <modal resizable name="open-slot" height="auto" :clickToClose="false"
    :adaptive="true"
    :scrollable="true">
      <book-lesson
        :selectedEvent="selectedEvent"
        :tiers="tiers"
        :teacher="teacher"
        @booked="setSlotBooked($event)"
        @cancel="setSlotFree($event)" />
    </modal>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
import dayjs from 'dayjs';
import {
  getTeacherTiers, getTeacherBySlug, getTeacherMasterclasses, getTeacherFreeSlots,
  getTeacherLockedSlots,
} from '@/services/TeacherService';
import BookLesson from '../modals/BookLesson.vue';

export default {
  components: { BookLesson },
  data() {
    return {
      teacher: {},
      teacherTimezone: '',
      isLogged: false,
      events: [],
      ready: false,

      selectedPrice: '',

      lastTimezone: '',

      selectedEvent: '',
      start: '',
      timeFrom: 24 * 60,
      timeTo: 0 * 60,

      tiers: [],
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      beenUpdatedSlots: 'slots/updatedSlots',
      choosenTimezone: 'timezone/choosenTimezone',
    }),

    screenWidth() {
      return window.innerWidth;
    },

  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  mounted() {
    if (this.user) {
      this.getSelectedTeacher(this.$route.params.slug);
      this.lastTimezone = this.user.timezone;
    }
  },

  watch: {
    beenUpdatedSlots() {
      // this.events = [];
      this.getSlots();
      this.updatedSlots(false);
      this.createNotification('warning', `${this.$t('bookingSlots.sorry')}<br>${this.$t('bookingSlots.please')}`);
    },

    choosenTimezone() {
      this.events = [];
      this.timeFrom = 24 * 60;
      this.timeTo = 0 * 60;
      this.getSlots();
    },
  },

  methods: {
    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
      setChoosenTimezone: 'timezone/setChoosenTimezone',
    }),

    getTiers() {
      getTeacherTiers(this.teacher.slug).then(({ data }) => {
        this.tiers = [];
        this.tiers = data;
      });
    },

    async getSelectedTeacher(slug) {
      getTeacherBySlug(slug).then((response) => {
        this.teacher = response.data;
        this.teacherTimezone = this.teacher.user.timezone;
        this.selectedPrice = this.teacher.lesson_price;
        this.getSlots();
        this.getTiers();
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    onEventClick(event, e) {
      e.stopPropagation();

      if (event.class === 'booked' || event.class === 'past' || event.class === 'lunch') {
        // alert('Gia Preso!');
        return;
      }

      if (event.class === 'masterclass') {
        this.$router.push('/masterclasses');
        return;
      }

      this.selectedEvent = event;
      axios.put(`/api/slots/${this.selectedEvent.id}/locked`).then((response) => {
        if (response.data !== null && response.data !== '') {
          this.$modal.show('open-slot');
        } else {
          this.updatedSlots(true);
        }
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    getSlots() {
      this.ready = false;
      getTeacherFreeSlots(this.teacher.id).then((response) => {
        response.data.forEach((slot) => {
          const returnArray = this.convertSlotForCalendar(slot, this.timeFrom, this.timeTo);

          const newEvent = returnArray.event;
          newEvent.booking_id = slot.booking_id;
          this.timeFrom = returnArray.timeFrom * 60;
          this.timeTo = returnArray.timeTo * 60;

          if (!this.events.some((event) => event.start === newEvent.start)) {
            this.events.push(newEvent);
          }
        });
        this.getMasterclasses();
        this.getLockedSlots();
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    getMasterclasses() {
      getTeacherMasterclasses(this.teacher.slug).then((response) => {
        response.data.forEach((masterclass) => {
          const returnArray = this.convertMasterclassForCalendar(
            masterclass, this.timeFrom, this.timeTo,
          );

          const newEvent = returnArray.event;
          this.timeFrom = returnArray.timeFrom * 60;
          this.timeTo = returnArray.timeTo * 60;

          if (!this.events.some((event) => event.start === newEvent.start)) {
            this.events.push(newEvent);
          }
        });
        this.ready = true;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    getLockedSlots() {
      getTeacherLockedSlots(this.teacher.id).then(({ data }) => {
        if (this.$route.query.booking) {
          const selectedSlot = data.find(
            (slot) => slot.booking_id === this.$route.query.booking,
          );
          const returnArray = this.convertSlotForCalendar(selectedSlot, this.timeFrom, this.timeTo);
          this.selectedEvent = returnArray.event;
          this.selectedEvent.booking_id = selectedSlot.booking_id;
          this.selectedEvent.start = new Date(this.selectedEvent.start);
          this.selectedEvent.end = new Date(this.selectedEvent.end);
          this.$modal.show('open-slot');
        }
      });
    },

    setSlotBooked(data) {
      const slot = this.events.find((event) => event.id === data.slot);
      slot.class = `booked bg-tiers-${data.color} text-white`;
    },

    setSlotFree(id) {
      const slot = this.events.find((event) => event.id === id);
      slot.class = 'free';
    },

    switchToTeacherTimezone() {
      this.lastTimezone = this.choosenTimezone;
      this.setChoosenTimezone(this.teacherTimezone);
      dayjs.tz.setDefault(this.choosenTimezone);
    },

    comeBackToChoosenTimezone() {
      this.setChoosenTimezone(this.lastTimezone);
      dayjs.tz.setDefault(this.choosenTimezone);
    },
  },
};
</script>

<style>
.vuecal--date-picker:not(.vuecal--day-view)
.vuecal__cell--selected .vuecal__cell-content {
    background-color: #D9C0A3;
    color: #fff;
}
.vuecal--date-picker:not(.vuecal--day-view) .vuecal__cell--today .vuecal__cell-content {
    border-color: #232626;
}
</style>
